var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('svg', {
    class: "fill-current  text-".concat(_vm.color),
    attrs: {
      "x": "0px",
      "y": "0px",
      "viewBox": "0 0 495 495",
      "height": "".concat(_vm.height, "px") || '24px',
      "width": "".concat(_vm.width, "px") || '24px'
    }
  }, [_c('g', [_c('path', {
    attrs: {
      "d": "M459.309,139.668c-5.755-14.947-17.567-26.415-31.989-31.97C419.092,86.29,398.449,72,375.5,72H220.865\n\t\tc-3.869-4.069-7.874-7.613-12.03-10.634l-18.703-20.041C174.495,24.283,156.625,16,135.5,16h-80C24.897,16,0,40.897,0,71.5v288\n\t\tc0,22.949,14.29,43.592,35.697,51.82c5.554,14.423,17.021,26.233,31.971,31.988C75.662,464.155,95.875,479,119.5,479h320\n\t\tc30.603,0,55.5-24.897,55.5-55.5v-232C495,167.875,480.156,147.662,459.309,139.668z M440.452,136.024\n\t\tc-0.318-0.005-0.633-0.024-0.952-0.024H282.759l-15.865-17H407.5C420.751,119,432.957,125.542,440.452,136.024z M408.448,104.019\n\t\tc-0.316-0.005-0.631-0.019-0.948-0.019h-152c-0.8,0-1.569,0.128-2.292,0.36c-6.48-6.882-13.34-12.292-20.656-16.236\n\t\tc0.032-0.374,0.043-0.749,0.019-1.124H375.5C388.752,87,400.954,93.539,408.448,104.019z M15,359.5v-288\n\t\tC15,49.168,33.168,31,55.5,31h80c15.656,0,28.68,5.582,40.722,17.512C173.375,48.183,170.473,48,167.5,48h-80\n\t\tC56.897,48,32,72.897,32,103.5v288c0,0.317,0.013,0.632,0.019,0.948C21.539,384.953,15,372.752,15,359.5z M47,391.5v-288\n\t\tC47,81.168,65.168,63,87.5,63h80c11.679,0,21.893,3.102,31.328,9.628l7.152,7.664C203.851,80.111,201.697,80,199.5,80h-80\n\t\tC88.897,80,64,104.897,64,135.5v288c0,0.319,0.019,0.634,0.024,0.952C53.542,416.958,47,404.755,47,391.5z M480,423.5\n\t\tc0,22.332-18.168,40.5-40.5,40.5h-320C97.168,464,79,445.832,79,423.5v-184c0-22.332,18.168-40.5,40.5-40.5h320\n\t\tc22.332,0,40.5,18.168,40.5,40.5V423.5z M439.5,184h-320c-15.964,0-30.365,6.784-40.5,17.61V135.5C79,113.168,97.168,95,119.5,95\n\t\th80c16.92,0,30.768,6.503,43.622,20.512l30.895,33.105c1.418,1.52,3.404,2.383,5.483,2.383h160c22.332,0,40.5,18.168,40.5,40.5\n\t\tv10.11C469.865,190.784,455.464,184,439.5,184z"
    }
  }), _c('path', {
    attrs: {
      "d": "M439.5,232h-88c-4.142,0-7.5,3.357-7.5,7.5s3.358,7.5,7.5,7.5h88c4.142,0,7.5-3.357,7.5-7.5S443.642,232,439.5,232z"
    }
  }), _c('path', {
    attrs: {
      "d": "M439.5,264h-88c-4.142,0-7.5,3.357-7.5,7.5s3.358,7.5,7.5,7.5h88c4.142,0,7.5-3.357,7.5-7.5S443.642,264,439.5,264z"
    }
  })])]);
}
var staticRenderFns = []

export { render, staticRenderFns }